"use client";

import { useState } from "react";
import { PasswordField } from "@/components/PasswordField";
import { ServerTool } from "@/components/ServerTool";
import { outputName } from "@/lib/files";
import { getTool } from "@/lib/tools";

const tool = getTool("unlock-pdf")!;

/** Unlock PDF (Phase 5, server): qpdf removes a password the user knows,
 *  and print/copy limits. */
export function UnlockPdfTool() {
  const [password, setPassword] = useState("");
  return (
    <ServerTool
      tool={tool}
      job="unlock"
      options={{ password }}
      button="Unlock PDF"
      result={(file, blob) => ({
        blob,
        name: outputName(file.name, "unlocked", "pdf"),
        detail: "No password needed any more",
      })}
    >
      <PasswordField
        label="The PDF's password"
        value={password}
        onChange={setPassword}
        autoComplete="off"
        hint="Leave empty if the PDF opens without one but won't let you print or copy."
      />
      <p className="text-sm text-ink">
        Only unlock PDFs that are yours or that you have permission to change.
      </p>
    </ServerTool>
  );
}
